'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import cmsItemsArrayIsEqual from '@haaretz/s-common-utils/cmsItemsArrayIsEqual';
import React from 'react';
const AuthorsContext = /*#__PURE__*/ React.createContext(undefined);
const AuthorsSetter = /*#__PURE__*/ React.createContext(undefined);
export function AuthorsProvider({ children, value: defaultAuthors }) {
    const [authors, setAuthors] = React.useState(defaultAuthors);
    const authorsSetter = React.useCallback((value)=>{
        if ((Array.isArray(value) || value === null) && !cmsItemsArrayIsEqual(value, authors)) {
            setAuthors(value);
        } else if (value && !Array.isArray(value) && typeof value === 'object' && Object.keys(value).length && !cmsItemsArrayIsEqual([
            value
        ], authors)) {
            setAuthors([
                value
            ]);
        }
    }, [
        authors
    ]);
    return /*#__PURE__*/ _jsx(AuthorsContext, {
        value: authors,
        children: /*#__PURE__*/ _jsx(AuthorsSetter, {
            value: authorsSetter,
            children: children
        })
    });
}
export default function useAuthors() {
    const context = React.use(AuthorsContext);
    if (context === undefined) {
        throw new Error('useAuthors must be used within a AuthorsProvider');
    }
    return context;
}
export function useSetAuthors() {
    const context = React.use(AuthorsSetter);
    if (context === undefined) {
        throw new Error('useSetAuthors must be used within a AuthorsProvider');
    }
    return context;
}
export function useAuthorsAtom() {
    return [
        useAuthors(),
        useSetAuthors()
    ];
}

//# sourceMappingURL=authorsAtom.js.map